import React from "react";
import "./Footer2.css";
const Footer2Main = () => {
  return (
    <div className="footer2MainContainer">
      <div className="footer2MainContent">
        <p>© 2008 - 2025 GoodWay Attestation. All Rights Reserved.</p>
        <p>Disclaimer: Goodway Attestation is an independent private document attestation and legalization service provider in Bangalore, Karnataka. We are not a governament authority, embassy, consulate or governament department and we do not represent any governament unless expressly stated and supposed by official authorization, Our services are limited to documents processing, attestation, legalization and related assistance. Governament requirements, fees, processing times and outcomes may vary depending on the document type and the concerned authority. We do not guarnatee visa approval, immigration approval, employment, admission or any governament decision.</p>
      </div>
    </div>
  );
};

export default Footer2Main;
